module.exports = __webpack_public_path__ + "img/icon-menu.c2fe9fa8.svg";